import styled from 'styled-components/macro';

export default {
	Container: styled.div`
		display: flex;
		flex-flow: column nowrap;
	`
};
